import dispatchEvent from "@cirrus/legacy/app-components/utils/dispatchEvent.es6"
import classNames from "classnames"
import PropTypes from "prop-types"
import React, { Component as C } from "react"

import Html from "./html.jsx"
import styles from "./table.less"

class Table extends C {
  static displayName = "Table"

  static propTypes = {
    className: PropTypes.string,
    tableContainerClassName: PropTypes.string,
    dataQa: PropTypes.string,
    id: PropTypes.string,
    dataSortableContainerId: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.string,
    ]),
  }

  componentDidMount() {
    dispatchEvent("scroll:x", this._container)
  }

  render() {
    const className = classNames(styles.table, this.props.className)
    const containerClasses = classNames(styles.tableContainer, this.props.tableContainerClassName)

    return (
      <div ref={(container) => (this._container = container)} className={containerClasses}>
        <Html
          dataSortableContainerId={this.props.dataSortableContainerId}
          type={this.props.htmlType}
          className={className}
          data-qa={this.props.dataQa}
          id={this.props.id}
          ariaLabel={this.props.ariaLabel}
          ariaDescribedBy={this.props.ariaDescribedBy}>
          {this.props.children}
        </Html>
      </div>
    )
  }
}

export default Table
